export default {
  sm: '0 2px 5px 0 rgba(0, 0, 0, 0.5)',
};
